import Ps from "perfect-scrollbar";

class SearchModalFilters {
  constructor(context, settings, $) {
    this.$ = $;
    this.elements = document.querySelectorAll(".c-search-modal-filters");

    if (this.elements === null) {
      return;
    }

    if (this.$('body').hasClass('employers-child-theme')) {
      const $caseStudyCheckbox = document.querySelector('[value="case_study"]');

      if ($caseStudyCheckbox && !$caseStudyCheckbox.checked) {
        this.HideRegionFilter();
      }

      this.checkFilterLabel();
    }

    this.elements.forEach((element) => {
      const filterBtns = element.querySelectorAll(
        ".c-search-modal-filters__filter-label"
      );
      filterBtns.forEach((filterBtn) => {
        if (filterBtn) {
          filterBtn.addEventListener("click", (e) => {
            e.preventDefault();
            this.toggleFilters(e.currentTarget);
          });
        }
      });

      const selectAllInputs = document.querySelectorAll(
        ".c-search-modal-filters__select-all-input"
      );
      if (selectAllInputs) {
        selectAllInputs.forEach((input) => {
          input.addEventListener("change", () => {
            const parentDropdown = input.closest(
              ".c-search-modal-filters__dropdown"
            );
            if (input.checked) {
              this.selectAll(parentDropdown.id);
              return;
            }

            this.clearFilterCheckBoxes(parentDropdown.id);
          });
        });
      }
    });

    const filterCheckboxes = document.querySelectorAll(
      ".c-search-modal-filters__item-checkbox"
    );
    filterCheckboxes.forEach((filterCheckbox) => {
      filterCheckbox.addEventListener("click", () =>{
        const mappedID = filterCheckbox.getAttribute('data-mapped-id');
        this.setMappedCheckbox(filterCheckbox.checked, mappedID)
      }
      );

    });

    const filters = Array.from(document.querySelectorAll('.c-search-modal-filters__filter'));
    filters.map(filter => {
      const checkedCheckboxes = filter.querySelectorAll('input:checked');
      if (checkedCheckboxes.length > 0) {
        const filterButton = filter.querySelector('button');
        if(filterButton){
          this.toggleFilters(filterButton);
        }
      }
    });
  }

  clearFilterCheckBoxes(filterId) {
    const filterLists = document.querySelectorAll(`#${filterId}`);
    filterLists.forEach((filterList) => {
      if (filterList) {
        const checkboxes = filterList.querySelectorAll("input[type=checkbox]");
        checkboxes.forEach((checkbox) => {
          checkbox.checked = false;
        });
      }
    });
  }

  selectAll(filterId) {
    const filterLists = document.querySelectorAll(`#${filterId}`);
    filterLists.forEach((filterList) => {
      if (filterList) {
        const checkboxes = filterList.querySelectorAll("input[type=checkbox]");
        checkboxes.forEach((checkbox) => {
          checkbox.checked = true;
        });
      }
    });
  }

  setMappedCheckbox(checked, mappedId) {
    const mappedCheckbox = document.querySelector(
      `#${CSS.escape(mappedId)}`
    );
    if (mappedCheckbox) {
      mappedCheckbox.checked = checked;
    }
  }



  toggleFilters(element) {
    const $elem = this.$(element);
    const $dropdown = $elem.next();
    $dropdown.toggleClass("is-open");
    $dropdown.slideToggle(300);

    $elem.toggleClass("is-clicked");

    if ($elem.hasClass("is-clicked")) {
      $elem.attr("aria-expanded", "true");
    } else {
      $elem.attr("aria-expanded", "false");
    }
  }

  HideRegionFilter() {
    const buttons = document.getElementsByClassName('js-filter-header');

    if (buttons.length > 0) {
      for (const button of buttons) {
        const filterButtonText = button.innerText.trim();
        const buttonParent = button.parentNode;

        if (filterButtonText === 'Region') {
          buttonParent.classList.add('is-hidden');
        }
      }
    }
  }

  checkFilterLabel() {
    const labels = document.getElementsByClassName('c-search-modal-filters__item-label');
    for (const label of labels) {
      const labelContent = label.innerText.trim().toLowerCase();
      if (labelContent === 'case study') {
        label.addEventListener('click', () => {
          const buttons = document.getElementsByClassName('js-filter-header');

          if (buttons.length > 0) {
            for (const button of buttons) {
              const filterButtonText = button.innerText.trim();
              const buttonParent = button.parentNode;
              const isHidden = buttonParent.classList.contains('is-hidden');

              if (isHidden) {
                buttonParent.classList.remove('is-hidden');
              } else {
                if (!isHidden && (filterButtonText === 'Region')) {
                  buttonParent.classList.add('is-hidden');
                }
              }
            }
          }
        });
      }
    }
  }

}

export default SearchModalFilters;
